import React, { useEffect, useRef } from 'react';
import './Popup.css';
import messageImage from '../../assets/img/support_agent.png';

interface BilgiPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

const BilgiPopup: React.FC<BilgiPopupProps> = ({ isOpen, onClose }) => {
  const popupRef = useRef<HTMLDivElement>(null);
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (isOpen) {
      closeButtonRef.current?.focus();
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div id="bilgi_popup" className={`popup-overlay ${isOpen ? 'open' : ''}`} style={{ zIndex: 9999999999 }} role="dialog" aria-modal="true" aria-labelledby="bilgi-popup-title">
      <div className="popup-backdrop" onClick={onClose} aria-label="Popup'u kapat"></div>
      <div className="popup-container bilgi-popup" ref={popupRef}>
        <button
          className="popup-close"
          onClick={onClose}
          aria-label="Popup'u kapat"
          ref={closeButtonRef}
        >
          <svg clipRule="evenodd" fillRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#fff">
            <path d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z"></path>
          </svg>
        </button>
        <h2 id="bilgi-popup-title" className="popup-title">AKLINIZA TAKILAN BİR SORU MU VAR?</h2>
        <div className="popup-content">
          <img
            src={messageImage}
            alt="Thermomix Danışmanı"
            className="popup-image"
            style={{ borderRadius: '50%' }}
            loading="lazy"
          />
          <div className="popup-text">
            <p>
              Thermomix Dünyası olarak size yardımcı olmaktan mutluluk duyarım.
              Aşağıdaki butona tıklayarak WhatsApp üzerinden bana ulaşabilir, aklınıza
              takılan tüm soruları dilediğiniz zaman sorabilirsiniz!
              <br /><br />
              Dilerseniz <a href="#bilgi-formu" className="popup-link" onClick={onClose}>Bilgi Formu</a>'nu doldurabilirsiniz!
            </p>
            <div className="popup-buttons">
              <a
                href="tel:05369900797"
                target="_blank"
                rel="noopener noreferrer"
                className="popup-btn popup-btn-secondary"
                aria-label="Danışmanı telefon ile ara"
              >
                Danışmanı Ara
              </a>
              <a
                href="https://wa.me/905369900797"
                target="_blank"
                rel="noopener noreferrer"
                className="popup-btn popup-btn-primary"
                aria-label="WhatsApp ile danışmana mesaj gönder"
              >
                Danışmana Mesaj Gönder
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BilgiPopup;

